import "firebase/firestore";

import "./static/fonts/index.css";

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
}
